import { TooltipedIconComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { useCustomAlarmsNavigation } from 'modules/settings/pods/settings-devices/settings-devices-configuration/hooks/use-custom-alarms-navigation/use-custom-alarms-navigation.hook';

export interface CustomAlarmEditCommandComponentProps {
    customAlarmId: string;
}

export const CustomAlarmEditCommandComponent: React.FC<CustomAlarmEditCommandComponentProps> = ({ customAlarmId }) => {
    const { t } = useTranslation();
    const { navigateToEdit } = useCustomAlarmsNavigation();

    return (
        <TooltipedIconComponent
            icon="write"
            tooltipText={t('settings.devices.custom-alarms.actions.edit')}
            family="outlined"
            onClick={(ev) => {
                ev.stopPropagation();
                navigateToEdit(customAlarmId);
            }}
            hideTooltip={true}
        />
    );
};
